import React, { useEffect, useState } from "react";

function SingleChoiceV2WithoutSubmit({
  question,
  choices,
  qKey,
  onChange,
  selectedChoice = { value: null, text: null, id: null },
}) {
  const [currentChoice, setChoice] = useState(selectedChoice);
  const handleChange = (choice) => {
    setChoice(choice);
    onChange(choice);
  };

  const Choices = choices.map((choice, index) => {
    return (
      <li key={index}>
        <label>
          <input
            type="radio"
            name={qKey}
            value={choice.value}
            id={choice.id}
            checked={currentChoice.value === choice.value}
            onChange={() => handleChange(choice)}
          />
          <span className="dot"></span>
          <span className="txt">{choice.text}</span>
        </label>
      </li>
    );
  });

  return (
    <>
      <h3 className="headtitle">{question}</h3>
      <ul className="list-unstyled list_radio_btn">{Choices}</ul>
    </>
  );
}

export default SingleChoiceV2WithoutSubmit;
